import { useModal } from '@shape-ds/components';
import { useTranslation } from 'react-i18next';
import { ASSET_PAGE } from 'config/paths';
import { useOilAnalysis } from '../../hooks/useOilAnalysis';
import { useVibrationAnalysis } from '../../hooks/useVibrationAnalysis';
import {
  useOilAnalysisMutation,
  useVibrationAnalysisMutation,
} from 'queries/externalReferences/queries';
import {
  handleOilAnalysisSave,
  handleVibrationAnalysisSave,
  ExtendedOilData,
  ExtendedVibrationTable,
} from '../../Helpers/helper';
import OilAnalysisTable from 'components/ExternalReferencesTables/OilAnalysisTable';
import VibrationAnalysisTable from 'components/ExternalReferencesTables/VibrationAnalysisTable';
import { ModalTitleWithButton } from '../ModalTitleWithButton';
import { AnalysisType } from './AnalysisButtons';

export const useAnalysisButtons = (assetId: string) => {
  const { t } = useTranslation();
  const { openModal } = useModal();
  //adicionar a lógica da aba, no query option
  const { editedOilAnalysisData } = useOilAnalysis(assetId);
  //adicionar a lógica da aba, no query option
  const { editedVibrationAnalysisData } = useVibrationAnalysis(assetId);
  const oilAnalysisMutation = useOilAnalysisMutation();
  const vibrationAnalysisMutation = useVibrationAnalysisMutation();

  const handleOpenModal = (type: AnalysisType) => {
    const TableAnalisys = type === 'OIL_ANALYSIS' ? OilAnalysisTable : VibrationAnalysisTable;
    const title = (
      <ModalTitleWithButton
        title={t(`monitoring:tables.tabsLabels.${type}`)}
        url={ASSET_PAGE(assetId)}
        urlLabel={t('case:Cases.openAsset')}
      />
    );

    openModal(<TableAnalisys assetId={assetId} isEvidenceTable={true} />, {
      title,
      className: 'evidences-btn-modal',
    });
  };

  const handleDelete = (type: AnalysisType) => {
    if (type === 'OIL_ANALYSIS') {
      handleOilAnalysisSave([], assetId, oilAnalysisMutation.mutate);
    } else {
      handleVibrationAnalysisSave([], assetId, vibrationAnalysisMutation.mutate);
    }
  };

  return {
    oilAnalysisData: editedOilAnalysisData as ExtendedOilData[] | undefined,
    vibrationAnalysisData: editedVibrationAnalysisData as ExtendedVibrationTable[] | undefined,
    handleOpenModal,
    handleDelete,
  };
};
